import { render } from "./EmojisVue.vue?vue&type=template&id=63348ec4"
import script from "./EmojisVue.vue?vue&type=script&lang=js"
export * from "./EmojisVue.vue?vue&type=script&lang=js"

import "./EmojisVue.vue?vue&type=style&index=0&id=63348ec4&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__